(() => {
  const id = "xencms:region--mobile-menu";

  Drupal.behaviors[id] = {
    attach: (context, settings) => {
      once(id, ".region--mobile-menu", context).forEach((region) => {
        const hamburgers = document.querySelectorAll(".hamburger");

        let isOpen = false;

        const toggleIsOpen = () => {
          isOpen = !isOpen;
          onion.toggle(region, isOpen);
          document.body.classList.toggle("overflow-hidden", isOpen);
          hamburgers.forEach(hamburger => {
            hamburger.offsetWidth;
            hamburger.classList.toggle("is-open", isOpen);
          });
        };

        hamburgers.forEach(hamburger => hamburger.addEventListener("click", toggleIsOpen));
        region.addEventListener("click", event => {
          if (event.target === region) toggleIsOpen();
        });

        const toggleMenu1 = (arrow) => {
          toggled = arrow.nextElementSibling.classList.contains('is-open');
          if (!toggled) {
            arrow.parentNode.parentNode.classList.add("dimmed");
          }else{
            arrow.parentNode.parentNode.classList.remove("dimmed");
          }
          arrow.classList.toggle("is-open", toggled == 1 ? false : true);
          arrow.parentNode.classList.toggle("is-open", toggled == 1 ? false : true);
          arrow.nextElementSibling.classList.toggle("is-open", toggled == 1 ? false : true);
        };
        
        setTimeout(() => {
          const level0 = document.querySelectorAll(".region--mobile-menu .menu--level-0__arrow");
          level0.forEach(arrow => arrow.addEventListener("click", () => toggleMenu1(arrow)));
        }, 100);
      });
    }
  };
})();
